import { CircularProgress, Grid } from "@mui/material";
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import InfoModal from "components/ui/InfoModal/InfoModal";
import CatalogueCard from "./CatalogueCard";
import CatalogueShareLinkModule from "./CatalogueShareLinkModuleTwo";
import { useLocation, useNavigate, useNavigationType, useParams, useSearchParams } from "react-router-dom";
import SortContext from "context/SortContext";
import { useGlobalContext } from "context/GlobalContext";
import CatalogueCardSkeleton from "./CatalogueCardSkeleton";
import { returnCatalogCard } from "utils/returnCatalogCard";
import { useGetAllCatalogs } from "../hooks/useGetAllCatalog";
import { useInView } from "react-intersection-observer";
import { toast } from "react-toastify";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, hasAccessPage, isAllowed } from "utils/checkUserRigths";
import CatalogueAddAndEditClientDetails from "./Settings/Activity/componets/CatalogueAddAndEditClientDetails";
import { useCreateCatalogClient } from "./Settings/Activity/hooks/useCreateCatalogClient";
import apiClient from "lib/api-client";
import { transformDataForCatalogDataPage } from "utils/transformdata";
import { ProductCard } from "components/ui";
import { getLimits } from "features/Setting/Limits/api/limitsApis";
import ShareToMyBinnysModal from "./ShareToMyBinnysModal.jsx";
import { useShareMyBinnysCatalog } from "./Settings/Activity/hooks/useShareCatalogToMyBinnys";
import { useFilter } from "context/FilterContext";
import CatalogueCardNew from "./CatalogueCardNew";
import SetSkeleton from "components/ui/Skeleton/SetSkeleton";
import { useDispatch, useSelector } from "react-redux";
import { clearCatalogListScrollTargetId } from "store/cartSlice";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

const CATALOG_LIST_SCROLL_RESTORE_KEY = "catalogListScrollRestoreY";

function CatalogueScreen() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const { id: routeCatalogId } = useParams();
  const [searchParams] = useSearchParams();
  const scrollToCatalogIdFromStore = useSelector((s) => s.catalogListNav?.scrollToCatalogId);
  const catalogScrollTargetId =
    routeCatalogId || searchParams.get("id") || location.state?.scrollToCatalogId || scrollToCatalogIdFromStore || undefined;

  const [shareLinkOpen, setShareLinkOpen] = useState(false);
  const [shareMyBinnysOpen, setShareMyBinnysOpen] = useState(false);
  const [currentCatalogDesigns, setCurrentCatalogDesigns] = useState(null);
  const userData = localStorage.getItem("userData");
  const { setSortOptions, setSelectedSortValue, search, selectedSortValue, sortOptions, setSearch } = React.useContext(SortContext);
  const { setFilterCount, setIsCatalogFilter, isCatalogFilter, setFilter, setFilterValues, createdByOptions, setCreatedByOptions, designRange, setDesignRange, filterValues, backendFilterValues, setBackendFilterValues,  } = useFilter();
  const {
    setCreateBtn,
    setCreateBtnName,
    setCreateBtnOption,
    setCountCart,
    setIsArchive,
    setCheckCatalogBeforeNavigate,
    infoModalOpen,
    setInfoModalOpen,
    setFilterChangeCount,
    setDisplayCount,
    dynamicfilterCount,
    setFilterChangeDesignCount,
    filterChangeCount,
    filterChangeDesignCount,
    setSearchResultCount,
    setDynamicFilterCount,
    setSearchPlaceHolder,
    archiveCatalog,
  } = useGlobalContext();
  const [currentCatalogueId, setCurrentCatalogueId] = useState(null);
  const [catalogueData, setCatalogueData] = useState([]);
  /** After scroll-to-catalog + Redux clear, skip one layout scroll-to-top that would undo scrollIntoView */
  const suppressNextCatalogListScrollToTop = useRef(false);
  const { ref, inView } = useInView({
    threshold: 1.0,
  });

  const sort = sortOptions.find((item) => item.id == selectedSortValue)?.type || "catalogDateDesc";
  const permissions = usePermissions();
  
  // const hasAccessAddCatalog = hasAccessPage(findSpecificPage("Catalog", Catalodd");
  const hasAccessAddCatalog = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions),"Catalog Access"),"create");
  const [userShareLinkData, setUserShareLinkData] = useState(JSON.parse(sessionStorage.getItem("userShareLinkData")) || []);
  const { mutate: createCatalogClient, isError: isclientAddError, isSuccess: isclientAddSuccess, isPending: isClientLoader } = useCreateCatalogClient();
  const {
    mutate: shareCatalog,
    isPending: isMyBinnysCatalog,
    isSuccess: isMyBinnysSuccess,
    isError: isMyBinnysError,
  } = useShareMyBinnysCatalog(() => {
    setShareMyBinnysOpen(false);
  });

  //   useEffect(() => {
  //   setIsCatalogFilter(true);

  //   return () => {
  //     setIsCatalogFilter(false); 
  //   };
  // }, []);



  const handleCardClick = (itemId) => {
    let catalogWithProduct = { itemId };
    let countLimit = itemId?.iconsData[0]?.count;
    sessionStorage.setItem("countLimit", JSON.stringify(countLimit));
    sessionStorage.setItem("catalogWithProduct", JSON.stringify(catalogWithProduct));
    sessionStorage.setItem("updateProductsData", JSON.stringify([]));
    let catalogNumberAndName = encodeURIComponent(`${itemId.number} (${itemId.subname})`);

    const isCrmFlow = Boolean(location.state?.crmSource);
    const state = {
      ...(isCrmFlow ? location.state : { edit: true, subName: "Edit" }),
      name: [`${itemId.number} (${itemId.subname})`],
      catalogueName: `${itemId.subname}`,
      isActivity: false,
      catalogSearch: search !== "" ? search : "",
    };
    setIsArchive(false);

    setCheckCatalogBeforeNavigate(false);
    sessionStorage.setItem(CATALOG_LIST_SCROLL_RESTORE_KEY, String(window.scrollY));
    navigate(`/Catalog/${itemId.id}?catalogNumberAndName=${catalogNumberAndName}`, { state });
  };

  const handleActivityClick = (itemId) => {
    const state = {
      name: [`Activity - ${itemId.number} (${itemId.subname})`],
      isActivity: true,
      catalogSearch: search !== "" ? search : "",
    };
    sessionStorage.setItem(CATALOG_LIST_SCROLL_RESTORE_KEY, String(window.scrollY));
    navigate(`/Catalog/${itemId.id}`, { state });
  };

  const handlCatalogueShareLink = (item) => {
    const newMap = new Map(catalogueData.map((item) => [item.id, item]));
    if (newMap.has(currentCatalogueId)) {
      let updateCatalgue = newMap.get(currentCatalogueId);
      updateCatalgue.iconsData = updateCatalgue.iconsData.map((ele, index) => {
        if (index == 1) {
          return {
            ...ele,
            count: ele.count + 1,
          };
        }
        return ele;
      });

      newMap.set(currentCatalogueId, updateCatalgue);
    }

    const updatedCatalogueData = Array.from(newMap.values());
    setCatalogueData(updatedCatalogueData);
  };

  const handleNewAccesUserAdd = (newUserData) => {
    let newData = {
      catalogId: currentCatalogueId?.id,
      clientNumber: newUserData.mobileNumber,
      clientName: newUserData.clientName,
      clientEmail: newUserData.clientEmail,
      bookType: newUserData.bookType,
      sessionDuration: newUserData.hours,
    };
    createCatalogClient(newData);
    // setShareLinkOpen(false);
  };

  const handleMyBinnysUserAndLinks = (catalogId) => {
    try {
      const state = {
        catalogId: catalogId.id,
        catalogName: [`${catalogId?.number} ( ${catalogId?.subname} )`],
        catalogSearch: search !== "" ? search : "",
      };
      navigate(`/CatalogSetting/${catalogId?.id}`, { state });
    } catch (error) {
      alert("Sonethiing went wrong");
    }
  };

  // --------->>>>>>> Share Catalog To My Binnys <<<<<<<<<<-------------

  const handleShareToMyBinnysPayload = (myBinnysClients) => {
    let data = {
      catalogId: currentCatalogueId?.id,
      myBinnysCompanyIds: myBinnysClients?.myBinnysCompanyIds,
      sessionDuration: myBinnysClients?.sessionDuration,
    };
    shareCatalog(data);
  };

  const handleCatalogSetting = (catalogId) => {
    const state = {
      catalogId: catalogId.id,
      catalogName: [`${catalogId.number} ( ${catalogId.subname} )`],
      catalogSearch: search !== "" ? search : "",
    };
    navigate(`/CatalogSetting/${catalogId.id}`, { state });
  };

  const handleButtonClick = async (itemId, btnTilte, e) => {
    e.stopPropagation();
    const userDataParsed = JSON.parse(userData);
    if (btnTilte === "Share Link") {
      //check limit
      let data = await getLimits(userDataParsed?._id);
      let designLimit = data?.exists?.sharingLimit;

      if (designLimit < itemId.numberOfStyles && !permissions?.isAdmin) {
        return toast.error(`You can not share as your limit is ${designLimit}`);
      }

      setShareLinkOpen(true);
      setCurrentCatalogueId(itemId);
    } else if (btnTilte === "ActiveLog") {
      handleActivityClick(itemId);
    } else if (btnTilte === "EditCatalogue") {
      let data = await getLimits(userDataParsed?._id);
      let limit = data?.exists?.designAddLimit;

      if (itemId?.numberOfStyles >= limit) {
        return toast.error(`You cannot add as your limit is ${limit}`);
      }
      handleCardClick(itemId);
    } else if (btnTilte === "Share to") {
      //check limit
      let data = await getLimits(userDataParsed?._id);
      let designLimit = data?.exists?.sharingLimit;

      if (designLimit < itemId.numberOfStyles && !permissions?.isAdmin) {
        return toast.error(`Only catalogs with ${designLimit} designs can be shared.`);
      }
      setCurrentCatalogDesigns(itemId?.numberOfStyles);

      setShareMyBinnysOpen(true);
      setCurrentCatalogueId(itemId);
    } else if (btnTilte === "users") {
      handleMyBinnysUserAndLinks(itemId);
    } else {
      handleCatalogSetting(itemId);
    }
  };

const createdBy = filterValues?.["Created By"]?.id || "";
  const designCount = filterValues && filterValues["Number of Designs"];
  const startDate = new Date(filterValues && filterValues["From Date To Date"]?.[0]);
  const endDate = new Date(filterValues && filterValues["From Date To Date"]?.[1]);


  const { data, isLoading, fetchNextPage, hasNextPage, isError, isFetching, isFetchingNextPage, error } = useGetAllCatalogs({
    limit: 18,
    sort: sort,
    search: search || "",
    isArchivefilter: false,
    createdBy,
    designCount,
    startDate,
    endDate,
  });

  useLayoutEffect(() => {
    if (catalogScrollTargetId) {
      return;
    }
    if (suppressNextCatalogListScrollToTop.current) {
      suppressNextCatalogListScrollToTop.current = false;
      return;
    }
    if (navigationType === "POP") {
      const raw = sessionStorage.getItem(CATALOG_LIST_SCROLL_RESTORE_KEY);
      if (raw != null && raw !== "") {
        const y = Number.parseInt(raw, 10);
        if (!Number.isNaN(y)) {
          window.scrollTo(0, y);
        }
        sessionStorage.removeItem(CATALOG_LIST_SCROLL_RESTORE_KEY);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [navigationType, catalogScrollTargetId, location.pathname]);

  useEffect(() => {
    if (!catalogScrollTargetId) return;
    if (isLoading) return;

    const idFromStore = scrollToCatalogIdFromStore;
    const targetId = String(catalogScrollTargetId);

    const runScroll = () => {
      const el = document.getElementById(targetId);
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "center" });
        if (idFromStore != null && String(idFromStore) === targetId) {
          suppressNextCatalogListScrollToTop.current = true;
          dispatch(clearCatalogListScrollTargetId());
        }
      } else {
        window.scrollTo(0, 0);
        if (idFromStore != null && String(idFromStore) === targetId) {
          dispatch(clearCatalogListScrollTargetId());
        }
      }
    };

    const timeoutId = window.setTimeout(() => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(runScroll);
      });
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [catalogScrollTargetId, isLoading, data, dispatch, scrollToCatalogIdFromStore]);

  useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  useEffect(() => {
    setSearchPlaceHolder("Search By Catalog or Design Number");
    setSearch("");
    setSortOptions([
      { id: 1, name: "Created By Me", type: "createdByMe" },
      { id: 2, name: "Design Quantity (Low to High)", type: "designNoAsc" },
      { id: 3, name: "Design Quantity (High to Low)", type: "designNoDesc" },
      { id: 4, name: "Catalog Date (Oldest to Newest)", type: "catalogDateAsc" },
      { id: 5, name: "Catalog Date (Newest to Oldest)", type: "catalogDateDesc" },
      { id: 6, name: "Catalog Views (Low to High)", type: "catalogViewsAsc" },
      { id: 7, name: "Catalog Views (High to Low)", type: "catalogViewsDesc" },
      // { id: 8, name: "Latest Created Time", type: "catalogDateDesc" },
      { id: 8, name: "Latest Modified Time", type: "latestModified" },
    ]);

    setFilterCount(0);
    // setFilter(true);
        setIsCatalogFilter(true);
    sessionStorage.setItem("filterChangeCount", 0);
    setInfoModalOpen(false);

    return () => {
      setSearchPlaceHolder("");
      setSortOptions([]);
      setSelectedSortValue(null);
      setSearch("");
      sessionStorage.removeItem("appliedSortValue");
      // setFilter(false);
          setIsCatalogFilter(false);

      setFilterValues([])
      setBackendFilterValues([])
    };
  }, []);

  useEffect(() => {
    const fetchCatalogUsers = async () => {
      try {
        const response = await apiClient.get(
          "/api/v1/catalog/catalogUsernames",
        );

        const data = response?.data?.data;

        if (data) {
          const uniqueNames = [...new Set(data)];

          setCreatedByOptions(uniqueNames);
        }
        if (response?.data?.stats) {
          const min = response?.data?.stats?.lowestNumberOfStyles || 1;
          const max = response?.data?.stats?.highestNumberOfStyles || 1000;

          setFilterValues({
            "Number of Designs": [min, max] || [],
            "Created By": {},
            "From Date To Date": []
          });
          setBackendFilterValues({
            "Number of Designs": [min, max] || [],
          });
        }
      } catch (error) {
        console.error("Error fetching catalog users:", error);
      }
    };

    fetchCatalogUsers();
  }, [location]);


  useEffect(() => {
    if (search === "") {
      setDynamicFilterCount(true);
    }
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.pages[0]?.totalCatalogs);
      // setFilterChangeDesignCount(data?.pages[0]?.totalDesginCount);
      setSearchResultCount(data?.pages[0]?.totalCatalogs);
    } else {
      setSearchResultCount(data?.pages[0]?.totalCatalogs);
      setFilterChangeCount(filterChangeCount);
      // setFilterChangeDesignCount(filterChangeDesignCount);
    }
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      // setFilterChangeDesignCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  useEffect(() => {
    setCreateBtn(hasAccessAddCatalog);
    setCreateBtnName("Create Catalog");
    setCreateBtnOption([
      // { option: "By Category", link: "/Category", view: hasAccessPage(findSpecificPage("Category", permissions), "view") },
      { option: "By Category", link: "/Category", view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions),"Category Access"),"view")},
      // { option: "By Collection", link: "/Collection", view: hasAccessPage(findSpecificPage("Collection", permissions), "view") },
      { option: "By Collection", link: "/Collection", view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions),"Collection Access"),"view")},
      // { option: "By Set", link: "/Sets", view: hasAccessPage(findSpecificPage("Sets", permissions), "view") },
      { option: "By Set", link: "/Sets", view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions),"Sets Access"),"view")},
      // { option: "By Stock", link: "/Stock", view: hasAccessPage(findSpecificPage("Stock", permissions), "view") },
      { option: "By Stock", link: "/Stock", view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions),"Stocks Access"),"view")},
    ]);

    return () => {
      setCreateBtn(false);
      setCreateBtnName("");
      setCreateBtnOption([]);
    };
  }, []);

  useEffect(() => {
    sessionStorage.removeItem("updateProductsData");
    sessionStorage.removeItem("catalogWithProduct");
    sessionStorage.removeItem("countLimit");
    // sessionStorage.removeItem("CartData");
    // setCountCart(0);
    window.dispatchEvent(new Event("cartUpdated"));
  }, []);

  const debouncedFetchNextPage = useCallback(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage]);

  useEffect(() => {
    if (inView) {
      debouncedFetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage]);

  useEffect(() => {
    setSearch(location?.state?.catalogSearch || "");
  }, [location]);

  const isCatalogProductPresent = (data) => {
    if (data && data.pages && data.pages.length > 0) {
      return data.pages.some((page) => (page.catalogs && page.catalogs.length > 0) || (page.cardData && page.cardData.length > 0));
    }
    return false;
  };

  if (isError) {
    toast.error(`${error}`, {
      position: "top-right",
      autoClose: 2000,
    });
  }

  if (isLoading) {
    return <SetSkeleton count={18} isCatalogNewCard={true} />;
  }
  const fetchData = () => apiClient.get(`/api/v1/catalog/getCatalogInfo/${currentCatalogueId}`);

  const hasNoResults =
    search &&
    data?.pages?.every(
      (page) => !page?.catalogs?.length && !page?.cardData?.length
    );

  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  return (
    <>
      {isCatalogProductPresent(data) ? (
        <>
          <Grid
            container
            className="Grid-padding"
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "32px", rowGap: "32px" }}
          >
            {data?.pages?.map((page, pageIndex) => (
              <React.Fragment key={pageIndex}>
                {page?.catalogs
                  ?.filter((item) => {
                    const newItem = returnCatalogCard(item);
                    return !archiveCatalog?.includes(newItem?.id);
                  })
                  ?.map((item) => {
                    const newItem = returnCatalogCard(item);

                    return (
                      <div id={String(newItem.id)} key={newItem.id}>
                        <CatalogueCardNew
                          data={newItem}
                          handleButtonClick={handleButtonClick}
                          infoClick={(e) => {
                            e.stopPropagation();
                            setInfoModalOpen(true);
                            setCurrentCatalogueId(newItem.id);
                          }}
                        />
                      </div>
                    );
                  })}

                {page?.cardData?.map((design, index) => {
                  const curElement = transformDataForCatalogDataPage(design);
                  return (
                    <Grid key={`${index}-${curElement.id}`} item className="product">
                      <ProductCard
                        key={index}
                        data={curElement}
                        style={{
                          maxWidth: "430px",
                          minWidth: "430px",
                        }}
                      />
                    </Grid>
                  );
                })}
              </React.Fragment>
            ))}

            {isFetchingNextPage ? <SetSkeleton count={12} isCatalogNewCard={true} /> : ""}
            <div ref={ref} />
          </Grid>
          {/* <div style={{ color: "red" }}>{isFetching && !isFetchingNextPage ? <CircularProgress color="secondary" /> : null}</div> */}
          {/* {shareLinkOpen && <CatalogueShareLinkModule open={shareLinkOpen} setOpen={setShareLinkOpen} handleUpdateCatalogueShareLinkInfo={handlCatalogueShareLink} />} */}
          {
            <CatalogueAddAndEditClientDetails
              open={shareLinkOpen}
              setOpen={setShareLinkOpen}
              handleRef={handleNewAccesUserAdd}
              isError={isclientAddError}
              isSuccess={isclientAddSuccess}
              isLoading={isClientLoader}
            />
          }
          <ShareToMyBinnysModal
            open={shareMyBinnysOpen}
            handleClose={() => setShareMyBinnysOpen(false)}
            handleShareDataRef={handleShareToMyBinnysPayload}
            isLoading={isMyBinnysCatalog}
            currentCatalogDesigns={currentCatalogDesigns}
          />
        </>
      ) : (
        <div
          style={{
            display: "flex",
            textAlign: "center",
            margin: "auto",
            padding: "auto",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <Background />
        </div>
      )}

      <InfoModal open={infoModalOpen} setOpen={setInfoModalOpen} fetchData={fetchData} title="Catalog Details" />
    </>
  );
}

export default CatalogueScreen;